export default __webpack_public_path__ + "static/media/Info_circle_yellow.605fe87a.svg";